import { useCallback, useContext, useRef, useState } from "react";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import TreeLoading from "../Trees/TreeLoading";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import ExpandCollapse from "../Search/ExpandCollapse";
import SearchButton from "../Search/SearchButton";
import CategoryIcon from "@mui/icons-material/Category";
import WorkflowTemplateTree from "../Trees/WorkflowTemplateTree";
import WorkflowTemplateOptionsMenu from "../RightContextMenu/WorkflowTemplateOptionsMenu";
import { FIELD_TYPE, OTHER_TYPE, RECORD_TYPE } from "../../constants/datatypes";

export default function VisualWorkflowTreePanel({targetId}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  // const [headerTrailerActive, setHeaderTrailerActive] = useState(true);
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree, leftTree } = useSelector((state) => state.treeData?.[parentScreen] ?? {});
  const [isCopied,setIsCopied] = useState({ copy: false, paste: false })
  const [expandActions,setExpandActions] = useState({tab:'',keys:[]});
  const leftSelectedNode = leftTree.tree.body.selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const [deleteErrorModal,setDeleteErrorModal] = useState(false);
  const [deleteErrorMessage,setDeleteErrorMessage] = useState('')
  const rightSelectedNode = rightTree?.tree?.body?.selectedNode;
  const content = t('LBL_NO_HEADER_TRAILER_ALLOWED').replace('{0}', templateHeader?.FILETYPE).split('\\n').map((str, idx) => <div key={idx}>{str ? str : <br />}</div>);
  useEffect(() => {
    setDisabled(leftSelectedNode?.type !== 'workflow');
  }, [leftSelectedNode?.key])

  const handleKeyDown = useCallback((event)=>{
    if (event.ctrlKey && rightSelectedNode) {
      if (event.key === "c" || event.key === "C") {
        setIsCopied({...isCopied, paste: false, copy: true,treeType:parentScreen });
      } else if (event.key === "v" || event.key === "V") {
        setIsCopied({ ...isCopied,paste:true,dispatchFrom:'keyPress',treeType:parentScreen});
      }
    } 
  },[isCopied, rightSelectedNode, parentScreen]);



  return (
    <div
      id="wf-tree"
      onKeyDown={(e)=>{
        if (document?.activeElement?.id !== "wf-tree") return;
        handleKeyDown(e, isCopied)
      }} 
      tabIndex={0} 
      className="flex-column height-100"
    >
      
      <div
        style={{
          height: "32px",
          borderBottom: "1px solid #e0e0e0",
          width: "100%",
          display: "flex",
          justifyContent: "space-between"
        }}>
        <Button
          size="small"
          className="left-tree-tab-button"
          sx={{ cursor: "unset", pointerEvents: "none", display: "flex", alignItems: "center" }}
        >
          <>
            {/* <CategoryIcon fontSize="small" className="margin-right-4" /> */}
            {t("TIT_WORKFLOW_ITEMS")}
          </>
        </Button>
        <div style={{display: "flex", alignItems: "center", borderLeft: "1px solid #e0e0e0", paddingLeft: "8px" }}>
          <SearchButton setExpandActions={setExpandActions} />
          <ExpandCollapse setExpandActions={setExpandActions} />
        </div>
      </div>
      <Box sx={{flex: "1", overflow: "auto"}}  id="visualWorkflowTree">

        {/* body */}
        <div className={"height-100"}>
          <div className="height-100 overflow-auto">
            {
              rightTree.tree.body.translatedData?.length > 0 ?
                <WorkflowTemplateTree expandActions={expandActions} tab="body" />
                : rightTree.loading ? <TreeLoading />
                  : rightTree.fetchError ? <div className="panel-fetch-error">{t('ERROR_FETCHING_TEMPLATE')}</div>
                    : leftTree?.tree?.body?.selectedNode?.type === "workflow" ? <div className="panel-no-data"></div>
                      : <div className="panel-no-data">{t("LBL_NO_WORKFLOW_ITEM_SELECTED")}</div>
            }
          </div>
        </div>

        {/* {contextMenuOptions} */}
        {(Object.keys(leftSelectedNode).length > 0 && leftSelectedNode?.type === 'workflow') && <WorkflowTemplateOptionsMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId="visualWorkflowTree" />}
      </Box>
    </div>
  );
}
